import { Rotate } from "react-awesome-reveal"

export const ProcessItem = ({count, title,content, pos='top' ,delay=0}) => {

    return <Rotate  delay={delay}>
      <div className={`process-item ${pos}`}>
      <div className="p-3">
      <p className='count text-center text-primary mb-0'>{count}</p>
        <h3 className="title text-center text-white py-3 h5 mb-0">{title}</h3>
        <div className="line mb-3"></div>
        <p className="content text-center text-white mb-0">{content}</p>
      </div>
    </div>
    </Rotate>
}
